import { createContext, useContext } from 'react';

export enum View {
  LISTINGS = 'listings',
  MAP = 'map',
}

export interface ViewTracker {
  view: View;
  setView: (view: View) => void;
}

export const ViewTrackerContext = createContext({} as ViewTracker);

export function useViewTrackerContext() {
  return useContext(ViewTrackerContext);
}
